import React, { useState } from 'react';
import { PropertyGrid } from '@property';

export default function AssistantHome(props) {

  return (
    <PropertyGrid />
  );
}
